export default __webpack_public_path__ + "static/media/thumbnail.2beb27f7.png";